import { TableCell, TableRow } from '@mui/material';
import { flexRender } from '@tanstack/react-table';
import classSet from 'react-classset';

const FuelTableRow = ({ row, rowRefs }: { row: any; rowRefs: any }) => {
  const getTableCellWidth = (cell) => {
    if (cell.column.id === 'select') return cell.column.columnDef.minSize;
    return cell.column.columnDef.width ? cell.column.columnDef.width : cell.column.getSize();
  };

  const renderRowStyle = (row) =>
    classSet({
      'fuel-table-row': true,
      'fuel-table-row--disabled': row.original.isDeleted && row.original.entityType === 'Clip',
      'fuel-table-row--expired': row.original.cssClassForExpired,
      'fuel-table-row--embargoed': row.original.cssClassForEmbargoed,
      'fuel-table-row--isGlobalInterstitialsChannel': row.original.isGlobalInterstitialsChannel,
      'fuel-table-row--parent': row.original.isParentChannel, // For parent row styling if needed
    });

  return (
    <>
      {/* Parent Row */}
      <TableRow
        className={renderRowStyle(row)}
        data-key={row?.original?.id || row.id}
        data-id={row?.original?.id || row.id}
        id={row?.original?.id || row.id}
        ref={(el) => {
          if (rowRefs && row && row.original && row.original.id) {
            rowRefs.current[row.original.id] = el;
          }
        }}
      >
        {row.getVisibleCells().map((cell, cellIndex) => (
          <TableCell
            data-key={cellIndex}
            key={cellIndex}
            {...{
              style: {
                width: getTableCellWidth(cell),
                maxWidth: getTableCellWidth(cell),
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                height: '54px',
                padding: '0px',
                paddingLeft: cell.column.columnDef.align === 'left' ? '8px' : '0px',
                paddingRight: cell.column.columnDef.align === 'right' ? '8px' : '0px',
                textAlign: cell.column.columnDef.align || 'center',
              },
            }}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
};

export default FuelTableRow;
